const Separation = () => {
  return <div style={{width: '2px', height: '100%', backgroundColor: '#D6E2F3'}}></div>
}

export default Separation
